// //navbar logo fixed in this code
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import AppBar from "@material-ui/core/AppBar";
import { useMediaQuery, useTheme } from "@mui/material";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";

import MenuIcon from "@material-ui/icons/Menu";

import logo from "../../assets/images/RX-coder-logo.png";
import {
  DEVELOPER_TAB,
  HOME_TAB,
  PERCEPTIVITI,
  PRICING_STATUS,
  PRICING_TAB,
  SEARCH_TAB,
} from "../../utils/constants";

export default function CustomNavbar() {
  const { pathname } = useLocation();

  const theme = useTheme();
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleMenu = (event) => {
    setAnchor(event.currentTarget);
  };

  const handleLinkClick = () => {
    window.location = PERCEPTIVITI;
  };

  let tabName;
  if (pathname === "/") {
    tabName = HOME_TAB;
    document.title = "Home - RXCoder";
  } else if (pathname === "/developer") {
    tabName = DEVELOPER_TAB;
    document.title = "Developer - RXCoder";
  } else if (pathname === "/pricing") {
    tabName = PRICING_TAB;
    document.title = "Pricing - RXCoder";
  } else if (pathname === "/search") {
    tabName = SEARCH_TAB;
    document.title = "Search - RXCoder";
  } else {
    tabName = HOME_TAB;
  }

  return (
    <>
      <AppBar
        position="sticky"
        className="custom-navbar"
        style={{
          backgroundColor: "white",
          boxShadow: "none",
          zIndex: 1,
        }}
      >
        <Toolbar
          className="d-flex justify-content-between"
          style={{ padding: "0" }}
        >
          <div className="d-flex">
            <Link
              to="/home"
              style={{ display: "block", lineHeight: 0, padding: 0, margin: 0 }}
            >
              <img
                style={{
                  verticalAlign: "top",
                  maxHeight: "150px",
                  width: "auto",
                }}
                src={logo}
                height={120}
                alt="RXCoder"
              />
            </Link>
          </div>
          {isMobile ? (
            <>
              <IconButton edge="start" aria-label="menu" onClick={handleMenu}>
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchor}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={open}
              >
                <MenuItem
                  onClick={() => setAnchor(null)}
                  component={Link}
                  to="/"
                >
                  <Typography variant="h6"> Home</Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => setAnchor(null)}
                  component={Link}
                  to="/developer"
                >
                  <Typography variant="h6"> Developer </Typography>
                </MenuItem>
                {PRICING_STATUS ? (
                  <MenuItem
                    onClick={() => setAnchor(null)}
                    component={Link}
                    to="/pricing"
                  >
                    <Typography variant="h6"> Pricing</Typography>
                  </MenuItem>
                ) : (
                  ""
                )}
                <MenuItem
                  onClick={() => {
                    setAnchor(null);
                    handleLinkClick();
                  }}
                >
                  <Typography variant="h6"> About </Typography>
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <div className="navbar" style={{ display: "flex", gap: "20px" }}>
                <div>
                  <Link
                    className={
                      tabName === HOME_TAB
                        ? "nav-link text-uppercase active"
                        : "nav-link text-uppercase"
                    }
                    to="/home"
                  >
                    Home
                  </Link>
                </div>
                <div>
                  <Link
                    className={
                      tabName === DEVELOPER_TAB
                        ? "nav-link text-uppercase active"
                        : "nav-link text-uppercase"
                    }
                    to="/developer"
                  >
                    Developer
                  </Link>
                </div>
                {PRICING_STATUS ? (
                  <div>
                    <Link
                      className={
                        tabName === PRICING_TAB
                          ? "nav-link text-uppercase active"
                          : "nav-link text-uppercase"
                      }
                      to="/pricing"
                    >
                      Pricing
                    </Link>
                  </div>
                ) : (
                  ""
                )}
                <div
                  tabIndex="0"
                  role="button"
                  className="nav-link text-uppercase"
                  variant="text"
                  onClick={handleLinkClick}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleLinkClick();
                    }
                  }}
                >
                  About
                </div>
              </div>
            </>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
}


// code for preferences
// import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import AppBar from "@material-ui/core/AppBar";
// import { useMediaQuery, useTheme } from "@mui/material";
// import IconButton from "@material-ui/core/IconButton";
// import Toolbar from "@material-ui/core/Toolbar";
// import Menu from "@material-ui/core/Menu";
// import MenuItem from "@material-ui/core/MenuItem";
// import Typography from "@material-ui/core/Typography";
// import Radio from "@material-ui/core/Radio";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import Popover from "@material-ui/core/Popover";
// import MenuIcon from "@material-ui/icons/Menu";
// import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
// import logo from "../../assets/images/drugCoderlogo.png";
// import {
//   DEVELOPER_TAB,
//   HOME_TAB,
//   PERCEPTIVITI,
//   PRICING_STATUS,
//   PRICING_TAB,
//   SEARCH_TAB,
// } from "../../utils/constants";

// export default function CustomNavbar() {
//   const { pathname } = useLocation();
//   const theme = useTheme();
//   const [anchor, setAnchor] = useState(null);
//   const [preferencesAnchor, setPreferencesAnchor] = useState(null);
  
//   // Initialize state from local storage with default 'drug Code'
//   const [selectedFormat, setSelectedFormat] = useState(() => {
//     const savedFormat = localStorage.getItem('drugOutputFormat');
//     return savedFormat || 'drug Code';
//   });

//   const open = Boolean(anchor);
//   const preferencesOpen = Boolean(preferencesAnchor);
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   // Update local storage whenever selected format changes
//   useEffect(() => {
//     localStorage.setItem('drugOutputFormat', selectedFormat);
//   }, [selectedFormat]);

//   const handleMenu = (event) => {
//     setAnchor(event.currentTarget);
//   };

//   const handlePreferencesOpen = (event) => {
//     setPreferencesAnchor(event.currentTarget);
//   };

//   const handlePreferencesClose = () => {
//     setPreferencesAnchor(null);
//   };

//   const handleLinkClick = () => {
//     window.location = PERCEPTIVITI;
//   };

//   const handleFormatChange = (format) => {
//     setSelectedFormat(format);
//   };

//   let tabName;
//   if (pathname === "/") {
//     tabName = HOME_TAB;
//     document.title = "Home - drug-Coder";
//   } else if (pathname === "/developer") {
//     tabName = DEVELOPER_TAB;
//     document.title = "Developer - drugCoder";
//   } else if (pathname === "/pricing") {
//     tabName = PRICING_TAB;
//     document.title = "Pricing - drugCoder";
//   } else if (pathname === "/search") {
//     tabName = SEARCH_TAB;
//     document.title = "Search - drugCoder";
//   } else {
//     tabName = HOME_TAB;
//   }

//   const PreferencesMenu = () => (
//     <Popover
//       open={preferencesOpen}
//       anchorEl={preferencesAnchor}
//       onClose={handlePreferencesClose}
//       anchorOrigin={{
//         vertical: 'bottom',
//         horizontal: 'center',
//       }}
//       transformOrigin={{
//         vertical: 'top',
//         horizontal: 'center',
//       }}
//     >
//       <div style={{ padding: '16px', display: 'flex', flexDirection: 'column' }}>
//         <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
//           Output Format
//         </Typography>
//         <FormControlLabel
//           control={
//             <Radio
//               checked={selectedFormat === 'drug Code'}
//               onChange={() => handleFormatChange('drug Code')}
//               color="primary"
//             />
//           }
//           label="drug Code"
//         />
//         <FormControlLabel
//           control={
//             <Radio
//               checked={selectedFormat === 'Nphies Code'}
//               onChange={() => handleFormatChange('Nphies Code')}
//               color="primary"
//             />
//           }
//           label="Nphies Code"
//         />
//       </div>
//     </Popover>
//   );

//   return (
//     <>
//       <AppBar
//         position="sticky"
//         className="custom-navbar"
//         style={{
//           backgroundColor: "white",
//           boxShadow: "none",
//           zIndex: 1,
//         }}
//       >
//         <Toolbar
//           className="d-flex justify-content-between"
//           style={{ padding: "0" }}
//         >
//           <div className="d-flex">
//             <Link to="/home" style={{ display: "block" }}>
//               <img
//                 style={{ verticalAlign: "top" }}
//                 src={logo}
//                 height={50}
//                 alt="RXCoder"
//               />
//             </Link>
//           </div>
//           {isMobile ? (
//             <>
//               <IconButton edge="start" aria-label="menu" onClick={handleMenu}>
//                 <MenuIcon />
//               </IconButton>
//               <Menu
//                 id="menu-appbar"
//                 anchorEl={anchor}
//                 anchorOrigin={{
//                   vertical: "top",
//                   horizontal: "right",
//                 }}
//                 keepMounted
//                 transformOrigin={{
//                   vertical: "top",
//                   horizontal: "right",
//                 }}
//                 open={open}
//                 onClose={() => setAnchor(null)}
//               >
//                 <MenuItem
//                   onClick={() => setAnchor(null)}
//                   component={Link}
//                   to="/"
//                 >
//                   <Typography variant="h6"> Home</Typography>
//                 </MenuItem>
//                 <MenuItem
//                   onClick={() => setAnchor(null)}
//                   component={Link}
//                   to="/developer"
//                 >
//                   <Typography variant="h6"> Developer </Typography>
//                 </MenuItem>
//                 {PRICING_STATUS ? (
//                   <MenuItem
//                     onClick={() => setAnchor(null)}
//                     component={Link}
//                     to="/pricing"
//                   >
//                     <Typography variant="h6"> Pricing</Typography>
//                   </MenuItem>
//                 ) : (
//                   ""
//                 )}
//                 <MenuItem
//                   onClick={() => {
//                     setAnchor(null);
//                     handleLinkClick();
//                   }}
//                 >
//                   <Typography variant="h6"> About </Typography>
//                 </MenuItem>
//                 <MenuItem onClick={handlePreferencesOpen}>
//                   <Typography variant="h6" style={{ display: 'flex', alignItems: 'center' }}>
//                     Preferences
//                     <ArrowDropDownIcon style={{ marginLeft: '4px' }} />
//                   </Typography>
//                 </MenuItem>
//               </Menu>
//               <PreferencesMenu />
//             </>
//           ) : (
//             <>
//               <div 
//                 className="navbar" 
//                 style={{ 
//                   display: 'flex', 
//                   gap: '20px',
//                   alignItems: 'center'
//                 }}
//               >
//                 <div>
//                   <Link
//                     className={
//                       tabName === HOME_TAB
//                         ? "nav-link text-uppercase active"
//                         : "nav-link text-uppercase"
//                     }
//                     to="/home"
//                   >
//                     Home
//                   </Link>
//                 </div>
//                 <div>
//                   <Link
//                     className={
//                       tabName === DEVELOPER_TAB
//                         ? "nav-link text-uppercase active"
//                         : "nav-link text-uppercase"
//                     }
//                     to="/developer"
//                   >
//                     Developer
//                   </Link>
//                 </div>
//                 {PRICING_STATUS ? (
//                   <div>
//                     <Link
//                       className={
//                         tabName === PRICING_TAB
//                           ? "nav-link text-uppercase active"
//                           : "nav-link text-uppercase"
//                       }
//                       to="/pricing"
//                     >
//                       Pricing
//                     </Link>
//                   </div>
//                 ) : (
//                   ""
//                 )}
//                 <div
//                   tabIndex="0"
//                   role="button"
//                   className="nav-link text-uppercase"
//                   onClick={handleLinkClick}
//                   onKeyDown={(event) => {
//                     if (event.key === "Enter") {
//                       handleLinkClick();
//                     }
//                   }}
//                 >
//                   About
//                 </div>
//                 <div
//                   tabIndex="0"
//                   role="button"
//                   className="nav-link text-uppercase"
//                   style={{ display: 'flex', alignItems: 'center' }}
//                   onClick={handlePreferencesOpen}
//                   onKeyDown={(event) => {
//                     if (event.key === "Enter") {
//                       handlePreferencesOpen(event);
//                     }
//                   }}
//                 >
//                   Preferences
//                   <ArrowDropDownIcon style={{ marginLeft: '4px' }} />
//                 </div>
//               </div>
//               <PreferencesMenu />
//             </>
//           )}
//         </Toolbar>
//       </AppBar>
//     </>
//   );
// }
